(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifRouteLoading', swifRouteLoading);

    /**
    * @ngdoc directive
    * @name swif.ui:swifRouteLoading
    * @module swif.ui
    * @restrict E
    * @description
    *     Listen to router events and display loading screen.
    *     This is a core component that is used in the entry point just before the view
    * @usage
        <swif-route-loading></swif-route-loading>
        <div ng-view></div>
    **/
    function swifRouteLoading() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'partials/ui/route_loading.html',
            link: function (scope, element) {
                scope.route = {loading: false};
                scope.$on('$routeChangeStart', function(){
                    scope.route.loading = true;
                });
                scope.$on('$routeChangeSuccess', function(){
                    scope.route.loading = false;
                });

            }
        };
    }
})();
